import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0937b7ea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "field" }
const _hoisted_2 = ["for"]
const _hoisted_3 = ["value", "rows", "maxlength"]
const _hoisted_4 = {
  key: 0,
  class: "character-count"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", {
      for: _ctx.id,
      class: "label"
    }, _toDisplayString(_ctx.label), 9, _hoisted_2),
    _createElementVNode("textarea", _mergeProps(_ctx.$attrs, {
      value: _ctx.modelValue,
      onInput: _cache[0] || (_cache[0] = e => _ctx.$emit('update:modelValue', e.target.value)),
      class: "input",
      rows: _ctx.rows,
      maxlength: _ctx.maxLength
    }), null, 16, _hoisted_3),
    (_ctx.hasCharacterCounter)
      ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.modelValue.length) + " / " + _toDisplayString(_ctx.maxLength), 1))
      : _createCommentVNode("", true)
  ]))
}